import {Link as RouterLink} from 'react-router-dom';

import {colors} from 'shells/colors/colors';
import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import type {GetAiSearchResults_aiSearch_suggestions as AiSearchSuggestion} from 'nutshell-graphql-types';

import styles from './command-palette.module.css';

interface Props {
    suggestion: AiSearchSuggestion;
    isActive: boolean;
    innerRef: (el: HTMLDivElement | null) => void;
    onClick: () => void;
}

export function SearchResultAiSuggestion(props: Props) {
    return (
        <div ref={props.innerRef}>
            <Link
                // @ts-expect-error
                as={RouterLink}
                to={props.suggestion.path}
                className={props.isActive ? styles['result-row--active'] : styles['result-row']}
                onClick={props.onClick}
                preventUnderline={true}
            >
                <div className={styles['result-row-icon--ai']}>
                    <AiSparkleNewIcon
                        size={14}
                        // @ts-expect-error
                        color={colors.aiPurplePrimary}
                        alignCenter={true}
                    />
                </div>
                <div className='flex flex-dir-col flex-grow min-width-0'>
                    <Body size='normal' color='dark' truncate={{type: 'inline'}}>
                        {props.suggestion.label}
                    </Body>
                    {props.suggestion.description && (
                        <Body size='small' color='light' truncate={{type: 'inline'}}>
                            {props.suggestion.description}
                        </Body>
                    )}
                </div>
                <span className={styles['result-row-badge--ai']}>AI</span>
            </Link>
        </div>
    );
}
